import React, { useState, useEffect } from "react";
import { Card, Col, Divider, Row, Statistic, Table, Switch, Button, Tag, Tooltip, Input, message, Modal, Select, DatePicker, Descriptions, Flex } from "antd";

import { makeStyles } from "@mui/styles";

import { CheckCircleFilled, CheckOutlined, CloseCircleOutlined, CloseOutlined, DeleteFilled, EditOutlined, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Message from "../../Components/common/Message";
import AuthService from "../../Components/auth/AuthService";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { Pagination } from "@mui/material";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, InventorySuppliers, issuePriorities, maintenanceSuppliers } from "../../Components/common/constants";
import { useNavigate } from "react-router-dom";

import dayjs from "dayjs";
import { Autocomplete, Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import { extractOriginalFileName, getNewFileName } from "../../Components/common/CommonFun";
import { domain, env, tms_uploads_bucket, tms_uploads_cdn } from "../../Components/config";
import DeleteIcon from "@mui/icons-material/Delete";
import qs from 'query-string';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton } from "@mui/material"
const Auth = new AuthService();
const { RangePicker } = DatePicker;


const useStyles = makeStyles((theme) => ({
  dataSheet: {
    padding: "5px",
    
  },
}));

const PurchaseOrderList = () => {
  const classes = useStyles();
  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate();
  const [loadMessage, setLoadMessage] = useState("");
  const [type, setType] = useState("");
  const [allPurchaseOrders, setAllPurchaseOrders] = useState([]);
  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);

  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  const [dateRange, setDateRange] = useState(null);

  const [selectedText, setSelectedText] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  

  // const [closeModalVisible, setCloseModalVisible] = useState(false);
  // const [closeOrderData, setCloseOrderData] = useState({
  //   date: null,
  //   notes: "",
  //   files: [],
  // });

  // const handleCloseOrder = async () => {
  //       showLoading(layoutDispatch);
  //       const dataToSend = {
  //         id: closeOrderData.id,
  //         completion_date: moment(closeOrderData.date).format("YYYY-MM-DD"),
  //         notes: closeOrderData.notes,
  //         files: closeOrderData.files,
  //       }
  //       try {
  //         const res = await Auth.fetch(`/inventory/purchase-order`, {
  //           method: "PUT",
  //           body: JSON.stringify(dataToSend),
  //         });
  //         if (res?.ack) {
  //           const uploadPromises = []
  
  //             if (closeOrderData?.newFiles?.length > 0) {
  //               closeOrderData?.newFiles?.forEach((f) => {
  //                 uploadPromises.push(
  //                   getUploadUrl(f, closeOrderData.id)
  //                     .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
  //                     .catch(error => console.error("Error uploading file:", error))
  //                 );
  //               });
  //             }
  //             await Promise.all(uploadPromises);
  //             try {
  //               const postRes = await Auth.fetch(`/inventory/post-purchase-order`, {
  //                 method: "POST",
  //                 body: JSON.stringify({id: closeOrderData.id}),
  //               });
  //               if(postRes?.ack) {
  //                 setCloseOrderData({ date: null, notes: "", files: [] });
  //                 getAllPurchaseOrders();
  //                 message.success(postRes?.message);
  //               }
  //             } catch  (err){
  //               console.error(err);
  //               message.error(err?.message);
  //             }
  //           // message.success(res?.message);
  //         } else {
  //           message.error(res?.message);
  //         }
  //       } catch (err) {
  //         console.error(err);
  //         message.error(err?.message);
  //       } finally {
  //         hideLoading(layoutDispatch);
  //         setCloseModalVisible(false);
  //       }
  //     };
  

  const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };

  const deletePurchaseOrder = async (id) => {
        showLoading(layoutDispatch);
        try {
          const res = await Auth.fetch(`/inventory/purchase-order`, {
            method: "DELETE",
            body: JSON.stringify({ id: id })
    
          });
          if (res?.ack) {
            getAllPurchaseOrders();
            message.success(res?.message);
          } else {
            message.error(res?.message);
          }
        } catch (err) {
          console.log(err);
          message.error(err?.message);
        } finally {
          hideLoading(layoutDispatch);
        }
      };

  const purchaseOrderColumns = [
    {
      title: 'Order Date',
      render: (record)=> {
        return (
          <>
          <span>{ record.order_date ? dayjs(record.order_date).format(DATE_FORMAT) : ''}</span>
        </>
        )
      }
    },
    {
        title: 'Code',
        dataIndex: 'order_code',
        key: 'order_code',
    },
    
    {
          align: "center",
          title: "Supplier",
          render: ({ supplier_id }) => {
            const object = InventorySuppliers.find((obj) => obj.id == supplier_id);
            return (
              <span >
                {object?.title}
              </span>
            );
          },
        },
        {
          title: 'Action',
          key: 'action',
          align: 'right',
          render: (text, record) => (
            <Flex justify="end">
              {/* {record.status === 1 && (
            <CheckCircleFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                marginRight: "5px",
                color: "green",
              }}
              onClick={() => {
                setCloseOrderData({
                  ...record,
                  id: record.id,
                  date: new Date(),
                  notes: record.notes || "",
                  files: record.files ? JSON.parse(record?.files) : [],
                  newFile: []
                });
                setCloseModalVisible(true);
              }}
            />
          )} */}
              {
                record.status == 1 && (
                  <EditOutlined
            style={{
              fontSize: "25px",
              cursor: "pointer",
              marginRight: "5px",
              color: "#006cb8",
            }} onClick={() => navigate(`/workshop_purchase_order/${record.id}`)}/>
                )
              }
    
            
            {
              !record.posted_by > 0 && (
                <DeleteFilled style={
                  {
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Purchase Order',
                    centered: true,
                    content: `Are you sure you want to delete this purchase Order?`,
                    onOk:()=> deletePurchaseOrder(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large"  },
                    cancelButtonProps: { size: "large" },
                  });
                }} 
                />
              )
            }
            
            </Flex>
            )
        },
    
  ];

  const getAllPurchaseOrders = async (download) => {
    let search = {};
    if (page && pageChange) search.page = page;
    if (dateRange && dateRange[0]) search.start_date = moment(dateRange[0].toDate()).format("YYYY-MM-DD");
    if (dateRange && dateRange[1]) search.end_date = moment(dateRange[1].toDate()).format("YYYY-MM-DD");
    if (selectedText) search.text = selectedText;

        if (selectedSupplier) search.supplier_id = selectedSupplier;


   if (download) search.download = 1;

    showLoading(layoutDispatch);
    try {
    const res = await Auth.fetch("/inventory/purchase-orders", {
        method: "POST",
        body: JSON.stringify(search),
      });
      if (res?.ack) {
       if (download == 1) {
           window.open(res.file_url, "_blank", "noreferrer");
         } else {
        setAllPurchaseOrders(res?.purchase_orders);
        setTotalPages(Math.ceil(res?.total_count / limit));
        setTotalCount(res.total_count);
         }
      } else {
        setAllPurchaseOrders([])
        message.error(res?.message)
      }
    } catch (err){
        console.log(err);
        message.error(err?.message)
    } finally {
        hideLoading(layoutDispatch);
    }
  };

  useEffect(() => {
            message.config({
              top: window.innerHeight - 100, 
              duration: 3, 
            });
  }, []);

  useEffect(() => {
    const timeOutId = setTimeout(() => getAllPurchaseOrders(), 100);
    return () => clearTimeout(timeOutId);
  }, [
    page,
    dateRange,
      selectedSupplier,
      selectedText

  ]);

//   const handleDeleteFile = (fileName) => {
//     const updatedFiles = closeOrderData?.newFiles?.filter((file) => file.name !== fileName);
//     setCloseOrderData({...closeOrderData, newFiles: updatedFiles, files: closeOrderData?.files?.filter((item) => item !== fileName)});
  
  
//   };
  
//   const handleDeleteCurrentFile = (itemToDelete) => {
//     setCloseOrderData({...closeOrderData, files: closeOrderData?.files?.filter((item) => item !== itemToDelete)});
    
//   };

//   const handleSubmitImage = (e) => {
//     e.preventDefault();
//     let acceptedFiles = e.target.files;

//     for (let file of acceptedFiles) {
//       const randomString = Math.random().toString(36).substring(2, 10);
//       const newFileName = getNewFileName(file.name)
//       setCloseOrderData((prevData) => ({
//         ...prevData,
//         newFiles: [
//           ...prevData.newFiles,
//           {
//             name: newFileName,
//             display_name: file.name,
//             file: file,
//             ContentType: file.type,
//           },
//         ],
//         files: [...prevData.files, newFileName],
//       }));
      
//     }
//   };

// const getUploadUrl = async (file, recordID) => {
//   const params = {
//     bucket: tms_uploads_bucket,
//     ContentType: file.file.type,
//     Key: env + "/purchase-orders/" + recordID + "/" + file.name,
//   };
//   const response = await fetch(
//     `${domain}/generate-put-url?${qs.stringify(params)}`,
//     {
//       headers: {
//         "Content-Type": params.ContentType,
//       },
//     }
//   );
//   return response.json();
// };

// const uploadFileToS3 = async (uploadUrl, file, contentType) => {
//   const response = await fetch(uploadUrl.putURL, {
//     method: "PUT",
//     body: file,
//     headers: {
//       "Content-Type": contentType,
//     },
//   });
//   if (response.status !== 200) {
//     console.log('response', response);
//     message.error("File upload failed.")
//     throw new Error("File upload failed.");
//   }
// };


const updateFilters = (newValues) => {
    const existingFiltersString = localStorage.getItem('purchaseOrderFilters');
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};
  
    Object.assign(existingFilters, newValues);

    existingFilters.timestamp = new Date().getTime();
  
    const updatedFiltersString = JSON.stringify(existingFilters);
  
    localStorage.setItem('purchaseOrderFilters', updatedFiltersString);
  };

  const getFiltersOrDefault = () => {
    const existingFiltersString = localStorage.getItem('purchaseOrderFilters');
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};
    const currentTime = new Date().getTime();
    const expirationTime = 30 * 60 * 1000;
    

    if (existingFilters.timestamp && currentTime - existingFilters.timestamp < expirationTime) {
      if (!existingFilters.supplier) {
        existingFilters.supplier = null;
      }

      return existingFilters;
    } else {
      localStorage.removeItem('purchaseOrderFilters');
      return {};
    }
  };

  useEffect(() => {
    const initialState = getFiltersOrDefault();
    setSelectedSupplier(initialState?.supplier);

    if (initialState.hasOwnProperty('dateRange')) {
      setDateRange(initialState.dateRange ? [dayjs(initialState.dateRange[0]), dayjs(initialState.dateRange[1])] : null);
    } else if (initialState.hasOwnProperty('startDate') || initialState.hasOwnProperty('endDate')) {
      const start = initialState.startDate ? dayjs(initialState.startDate) : null;
      const end = initialState.endDate ? dayjs(initialState.endDate) : null;
      if (start || end) {
        setDateRange([start, end]);
      } else {
        const firstDay = dayjs().startOf('month');
        const lastDay = dayjs().endOf('month');
        setDateRange([firstDay, lastDay]);
      }
    } else {
      const firstDay = dayjs().startOf('month');
      const lastDay = dayjs().endOf('month');
      setDateRange([firstDay, lastDay]);
    }

    initialState.timestamp = new Date().getTime();
    updateFilters(initialState);
  }, []);

  return (
    <div className={classes.dataSheet}>
        <Flex justify="space-between" align="center">
        <h2 style={{ margin: 0}}>Purchase Order List</h2>
        <Button onClick={()=> navigate('/workshop_purchase_order/new')} type="primary" icon={<PlusOutlined />}>Add Purchase Order</Button>
        </Flex>
        <Grid container rowSpacing={2} columnSpacing={1.5}>
                <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
                  <label htmlFor="pcnDate">Date</label>
                  <RangePicker
                    format={DATE_FORMAT}
                    style={{ width: '100%' }}
                    size="large"
                    value={dateRange}
                    onChange={(dates) => {
                      setDateRange(dates);
                      setPageChange(false);
                      setPage(1);
                      updateFilters({
                        dateRange: dates ? [dates[0].format(DEFAULT_DATE_FORMAT), dates[1].format(DEFAULT_DATE_FORMAT)] : null,
                        page: 1
                      });
                    }}
                    // placeholder="Select Date"
                    allowClear={true}
                  />
                </Grid>

                
                <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
                          <label htmlFor="route">Supplier</label>
                          <Select
                              style={{
                                width: "100%",
                              }}
                              showSearch
                              allowClear
                              size="large"
                              value={selectedSupplier}
                              placeholder="Supplier"
                              filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={(value) => {
                                setSelectedSupplier(value)
                                setPageChange(false)
                                setPage(1)
                                 updateFilters({ supplier: value })

                              }}
                            >
                              {InventorySuppliers.slice().sort((a,b)=> a.title.localeCompare(b.title)).map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item?.title}
                                </Option>
                              ))}
                            </Select>
                        </Grid>
              </Grid>
                <Table
                  columns={purchaseOrderColumns}
                  style={{  marginTop: '10px' }}
                  scroll={{ x: 'max-content'}}
                  pagination={false}
                  dataSource={allPurchaseOrders}
                  footer={() => {
                    const startRecord = (page - 1) * limit + 1;
                    const endRecord = Math.min(page * limit, allPurchaseOrders?.length ? totalCount : 0); 
                    return `Showing ${startRecord}-${endRecord} of ${allPurchaseOrders?.length ? totalCount : "0"} Records`;
                  }}
                />
        
              <div style={{ float: "right", margin: "10px" }}>
                <Pagination
                  page={page}
                  count={totalPages}
                  variant="outlined"
                  color="primary"
                  onChange={handleChange}
                />
              </div>
      <Message type={type} msg={loadMessage} />
      {/* <Modal
        title="Close Purchase Order"
        visible={closeModalVisible}
        onOk={handleCloseOrder}
        onCancel={() => setCloseModalVisible(false)}
        okText="Close Order"
        cancelText="Cancel"
      >
        <Divider />
        {
          closeOrderData?.order_date ? (
            <Descriptions style={{ marginBottom: "1px" }} bordered size={"small"}>
              <Descriptions.Item
                label={`Date`}
                labelStyle={{ width: "200px" }}
              >
                <span>{moment(closeOrderData?.order_date).format('YYYY-MM-DD HH:mm:ss')} </span><br />

              </Descriptions.Item>
            </Descriptions>
          ) : null
        }
        {
          closeOrderData?.order_code ? (
            <Descriptions style={{ marginBottom: "1px" }} bordered size={"small"}>
              <Descriptions.Item
                label={`Code`}
                labelStyle={{ width: "200px" }}
              >
                <span>{closeOrderData?.order_code} </span><br />

              </Descriptions.Item>
            </Descriptions>
          ) : null
        }
        <div style={{ marginBottom: "10px" }}>
          <label>Completion Date</label>
          <DatePicker
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            size="large"
            value={closeOrderData.date ? dayjs(closeOrderData.date) : null}
            onChange={(_, dateStr) => setCloseOrderData({ ...closeOrderData, date: dateStr })}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>Notes</label>
          <Input.TextArea
            rows={4}
            value={closeOrderData.notes}
            onChange={(e) => setCloseOrderData({ ...closeOrderData, notes: e.target.value })}
          />
        </div>

        <div>
            <UploadButton
              component="label"
              variant="contained"
              sx={{ marginTop: "10px" }}
              startIcon={<CloudUploadIcon />}
            >
              Add files
              <input
                type="file"
                hidden
                multiple
                capture
                onChange={(e) => {
                  const myfiles = e.target.files;

                  if (myfiles.length > 10) {
                    message.error("A maximum of 10 images can be uploaded at a time.");
                    e.target.value = "";
                  } else {
                    handleSubmitImage(e);
                  }
                }}
              />
            </UploadButton>
          </div>

        {closeOrderData?.files?.length > 0 && <h4>Old Files:</h4>}
             <ul>
                  {closeOrderData?.files?.length > 0 &&
                    closeOrderData?.files
                      .filter(
                        (item) =>
                          !closeOrderData?.newFiles?.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const encodedFileName = item.replace(/\+/g, '%2B');
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${tms_uploads_cdn}/${env}/purchase-orders/${closeOrderData?.id}/${encodedFileName}`}
                              target="_blank"
                            >
                              {extractOriginalFileName(encodedFileName)}
                            </a>
                          </li>
                        );
                      })}
                </ul>
        <Divider />
              {closeOrderData?.newFiles?.length > 0 && <h4>New Files:</h4>}
                <ul>
                  {closeOrderData?.newFiles?.length > 0 &&
                    closeOrderData?.newFiles?.map((newFiles) => {
                      const encodedFileName = newFiles?.name?.replace(/\+/g, '%2B');
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(newFiles.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {extractOriginalFileName(encodedFileName)}
                        </li>
                      );
                    })}
                </ul>
        
      </Modal> */}
    </div>
  );
};

export default PurchaseOrderList;
